import React, { useEffect } from 'react';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { useTranslation, Trans } from 'react-i18next';
import { enableAnalytics } from '../../utils/gtag';
import { GA_TRACKING_ID } from '../../utils/constants';

const ConsentBanner: React.FC = () => {
  const { t } = useTranslation('components/consent');

  // On mount, if consent already given, enable analytics
  useEffect(() => {
    if (getCookieConsentValue('trAInedupCookieConsent') === 'true') {
      enableAnalytics(GA_TRACKING_ID);
    }
  }, []);

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('accept')}
      declineButtonText={t('decline')}
      enableDeclineButton
      cookieName="trAInedupCookieConsent"
      overlay={true}
      overlayClasses="overlay-class"
      style={{ 
        background: '#1a1a1a', 
        fontSize: '1.1rem',
        zIndex: 99999,
        borderTop: '4px solid #6C47FF',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
        padding: '20px'
      }}
      buttonStyle={{ 
        color: '#fff', 
        background: '#6C47FF', 
        fontSize: '1rem', 
        borderRadius: '6px',
        fontWeight: 'bold',
        padding: '12px 24px'
      }}
      declineButtonStyle={{ 
        color: '#fff', 
        background: '#4a4a4a', 
        fontSize: '1rem', 
        borderRadius: '6px',
        padding: '12px 24px'
      }}
      expires={365}
      onAccept={() => enableAnalytics(GA_TRACKING_ID)}
    >
      <div className="flex flex-col gap-2">
        <strong className="text-lg block mb-1">We value your privacy</strong>
        <Trans
          i18nKey="message"
          t={t}
          components={{
            1: <a href="/privacy" style={{ color: '#fff', textDecoration: 'underline', fontWeight: 'bold' }} aria-label={t('privacyLinkLabel', 'Privacy Policy')} tabIndex={0}> 
                  {t('privacyLinkText', 'Privacy Policy')}
                </a>
          }}
        />
      </div>
    </CookieConsent>
  );
};

export default ConsentBanner;